<template>
  <b-modal id="edit-category-privilege" size="lg" centered :title="title">
    <form id="edit-category-privilege-form" @submit.prevent="submit">
      <div class="row">
        <div class="col-sm-12 col-lg-6">
          <b-form-group label="EN Name">
            <b-form-input
              required
              v-model="form.title.en"
              :state="!!form.title.en"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-sm-12 col-lg-6">
          <b-form-group label="TH Name">
            <b-form-input
              required
              v-model="form.title.th"
              :state="!!form.title.th"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-lg-6">
          <b-form-group label="Published">
            <toggle-button
              :value="form.status.toLowerCase() === 'active'"
              :labels="true"
              @change="onSetActive"
            />
          </b-form-group>
        </div>
      </div>
    </form>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <b-button
        size="sm"
        variant="primary"
        type="submit"
        form="edit-category-privilege-form"
        >Save</b-button
      >
      <b-button size="sm" variant="secondary" @click="cancel()"
        >Cancel</b-button
      >
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    data: Object,
    onSave: Function,
    title: String,
  },
  data: () => ({
    form: {
      title: {
        th: '',
        en: '',
      },
      status: 'Inactive',
    },
  }),
  methods: {
    onSetActive($value) {
      this.form.status = $value.value ? 'Active' : 'Inactive'
    },
    submit(e) {
      e.preventDefault()
      this.onSave(this.form)
      this.$bvModal.hide('edit-category-privilege')
    },
  },
  watch: {
    data: function (newVal, oldVal) {
      this.form = Object.assign({}, newVal)
      this.form.title = Object.assign({}, newVal.title)
    },
  },
}
</script>

<style scoped>
#sub-domain-result {
  font-size: 14px;
  color: #000;
}
</style>
